import { TextareaHTMLAttributes, forwardRef } from 'react';
import { cn } from '../lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, invalid, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          'block w-full rounded-sm border bg-surface px-3 py-2.5 text-base text-ink placeholder:text-ink-muted',
          'transition-[border-color,box-shadow] duration-fast ease-enter',
          'focus-visible:outline-none focus-visible:border-primary focus-visible:shadow-focus',
          'disabled:bg-surface-sunken disabled:text-ink-disabled disabled:cursor-not-allowed',
          'hover:border-border-strong',
          'min-h-[88px] resize-y',
          invalid
            ? 'border-error focus-visible:border-error focus-visible:shadow-[0_0_0_4px_var(--color-error-soft)]'
            : 'border-border-soft',
          className,
        )}
        {...rest}
      />
    );
  },
);
